<template>
  <!-- 外卖商户 -->
  <div class="takeaway">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-date-picker size="medium" v-model="frTime" type="daterange" align="right" unlink-panels
          :default-time="['00:00:00', '23:59:59']" value-format='yyyy-MM-dd HH:mm:ss' format='yyyy-MM-dd HH:mm:ss'
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
          style="width: 380px" @change="nowPage=1;init()">
        </el-date-picker>

        <el-select class="x-flex-1 x-m-l-10" size="medium" v-model="partner_id" placeholder="商户名称" filterable remote
          :disabled="!showFrmx" :remote-method='fQuerySearchGys' @focus="fQuerySearchGys(partner_id,'ALL')"
          @change="fChgFrInfo('ALL')">
          <el-option v-for="item in orgListSub" :key="item.RC" :label="item.comp_name" :value="item.user_phone">
            <span style="float: left">{{ item.comp_name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.user_phone }}</span>
          </el-option>
        </el-select>
        <el-input placeholder="商户,服务商,项目名称" v-model="searchStr" size="medium" style="width: 310px"
          class="x-m-r-12 x-flex-1 x-m-l-10">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>
        </el-input>
        <!-- <el-checkbox v-model="mhYn">模糊</el-checkbox> -->
        <!-- <el-checkbox v-model="zcYn">非正常</el-checkbox> -->
      </div>
      <!-- <div class="x-flex" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
        <el-button v-if="showFrjs" type="danger" size="medium" @click="fOpenPop">分润结算</el-button>
      </div> -->
    </div>
    <el-card style="position: relative">
      <div class="x-flex x-p-b-10" style="cursor: pointer;">
        <div :class=' actTabs == "分润明细" ? "active":"" ' class="x-m-r-20  x-p-b-10" @click="actTabs = '分润明细'">分润明细</div>
        <div v-if="showShzf" :class=' actTabs == "商户付费" ? "active":"" ' class="x-m-r-20  x-p-b-10"
          @click="actTabs = '商户付费'">商户付费</div>
      </div>
      <div style="height: calc(100vh - 238px)">
        <vxe-table ref="xTable1" v-if="showTable" border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson"
            :key="item.title">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
              </div>
            </template>
          </vxe-column>
          <!-- <vxe-column fixed="right" title="操作" width="70" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-text-c">
                <el-button type="text" size="mini" @click="fModify(scope.row)" style="color: #2c8ff2">
                  编辑
                </el-button>
              </div>
            </template>
          </vxe-column> -->
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
          <span class='x-p-l-10' v-if='actTabs == "分润明细"'>支付金额：{{total.pay_money}}</span>
          <span class='x-p-l-10' v-if='actTabs == "分润明细"'>分润金额：{{total.ledger_money}}</span>
          <span class='x-p-l-10' v-if='actTabs == "商户付费"'>支付金额：{{total.buyer_pay_money}}</span>
          <span class="x-m-l-10" style="cursor: pointer;color: #409EFF;" @click="fExportDataEvent">导出</span>
        </div>
        <el-pagination background layout="sizes,prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-sizes="[50, 100, 200, 300, 400, 500,  1000]" :page-size="pageSize"
          @size-change="fSizeChange"
          :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="frPop" width="600px" :show-close="false" :close-on-click-modal="false" class="add-dialog">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">
          分润结算
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;" @click="fClose"></i>
        </div>
        <!-- <div class="x-flex">
          <el-button type="danger" size="small" @click="fSave">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div> -->
      </div>
      <el-row class="x-p-t-40" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">服务商名</div>
          <el-select class="x-flex-1" size="medium" v-model="frInfo.user_phone" placeholder="服务商名称" filterable remote
            :remote-method='fQuerySearchGys' @focus="fQuerySearchGys('')" @change="fChgFrInfo">
            <el-option v-for="item in orgListSub" :key="item.RC" :label="item.comp_name" :value="item.user_phone">
              <span style="float: left">{{ item.comp_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.user_phone }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col class="x-flex" style="line-height: 36px;" :span="12">
          <div class="x-w70">服务商ID</div>
          <div>
            {{frInfo.user_phone}}
          </div>
        </el-col>
      </el-row>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">未结金额</div>
          <div class="x-lh-32 x-font-20" style="color: #F56C6C;">
            {{frInfo.soft_fr_now_money}}
          </div>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w70">本次结算</div>

          <el-input class="x-flex-1" v-model="frInfo.money" size="small" @change="fRegMoney">
            <span slot="append">元</span>
          </el-input>
        </el-col>
      </el-row>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="24">
          <div class="x-w70">结算备注</div>
          <el-input class="x-flex-1" v-model="frInfo.remark" size="small"></el-input>
        </el-col>
      </el-row>
      <div class="x-text-r x-p-t-30">
        <el-button type="danger" size="small" @click="fSave">确认结算</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        partner_id: '',
        actTabs: '分润明细',
        activeName: '',
        radio: "条件查询",
        searchStr: "",
        mhYn: true, //
        zcYn: false, //
        nowPage: 1, // 当前页数
        pageSize: 50, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        state: '正常',
        option: [{
          val: '正常'
        }, {
          val: '停用'
        }],
        tableJson: [],
        tableJson2: [{
            title: "时间",
            width: "200",
            sortType: "chg_time",
          },
          {
            title: "服务商",
            width: "160",
            sortType: "partner_name",
          },
          {
            title: "项目名称",
            width: "140",
            sortType: "item_name",
          }, {
            title: "交易金额",
            width: "100",
            sortType: "pay_money",
          }, {
            title: "分润金额",
            width: "100",
            sortType: "ledger_money",
          }, {
            title: "服务商ID",
            width: "160",
            sortType: "partner_phone",
          }, {
            title: "商户名称",
            width: "200",
            sortType: "sh_name",
          },
          {
            title: "商户号",
            width: "160",
            sortType: "sh_phone",
          },

          {
            title: "分润方式",
            width: "200",
            sortType: "ledger_way",
          },
          {
            title: "分润系数",
            width: "200",
            sortType: "ledger_value",
          },
          {
            title: "备注",
            width: "200",
            sortType: "remark",
          },
        ],
        tableJson1: [{
            title: "支付时间",
            width: "160",
            sortType: "pay_time",
          }, {
            title: "支付类型",
            width: "200",
            sortType: "pay_desc",
          },
          {
            title: "支付金额",
            width: "160",
            sortType: "buyer_pay_money",
          },
          {
            title: "支付方式",
            width: "140",
            sortType: "pay_way",
          }, {
            title: "摘要",
            width: "300",
            sortType: "user_memo",
          }, {
            title: "商户手机",
            width: "160",
            sortType: "sh_phone",
          }, {
            title: "门店名称",
            width: "200",
            sortType: "sh_md_name",
          },
          {
            title: "软件版本",
            width: "160",
            sortType: "soft_bb",
          },
          {
            title: "商户类型",
            width: "200",
            sortType: "sh_type",
          },
          {
            title: "合作伙伴手机",
            width: "200",
            sortType: "partner_phone",
          },
          {
            title: "合作伙伴名",
            width: "200",
            sortType: "partner_name",
          },
        ],
        frPop: false, // 增加/修改用户
        frInfo: {
          money: 0
        },
        orgListSub: [],
        frTime: [],
        showTable: true,
        pickerOptions: {
          // 选择时间是的快捷方式
          shortcuts: [{
              text: "昨日",
              onClick: (picker) => {
                this.frTime = [this.bykApi.timeHelper.manyDaysAgo(1, 3) + ' 00:00:00', this.bykApi.timeHelper
                  .manyDaysAgo(1, 3) +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            }, {
              text: "今日",
              onClick: (picker) => {
                this.frTime = [this.bykApi.timeHelper.manyDaysAgo(0, 3) + ' 00:00:00', this.bykApi.timeHelper
                  .manyDaysAgo(0, 3) +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            },
            {
              text: "本月",
              onClick: (picker) => {
                this.frTime = [this.bykApi.timeHelper.getMonthStartDate() + ' 00:00:00', this.bykApi.timeHelper
                  .getMonthEndDate() +
                  ' 23:59:59'
                ]
                picker.$emit("pick", this.frTime);
              },
            }, {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        showFrmx: false,
        showFrjs: false,
        showShzf: false,
        total: {}
      };
    },
    watch: {
      actTabs(newVal) {
        if (newVal == '分润明细') {
          this.tableJson = this.tableJson2
        } else {
          this.tableJson = this.tableJson1
        }
        this.showTable = false
        this.$nextTick(() => {
          this.nowPage = 1;
          this.showTable = true
          this.init()
        })
      },
      state() {
        this.init();
      },
      zcYn() {
        this.nowPage = 1
        this.init();
      }
    },
    async created() {
      this.showFrmx = await this.bykApi.global.fGetSmMenuQx('分润明细')
      this.showFrjs = await this.bykApi.global.fGetSmMenuQx('分润结算')
      this.showShzf = await this.bykApi.global.fGetSmMenuQx('商户支付')

      console.log(this.$route.query.partnerId)
      //
      this.frTime = [this.bykApi.timeHelper.manyDaysAgo(0, 3) + ' 00:00:00', this.bykApi.timeHelper
        .manyDaysAgo(0, 3) +
        ' 23:59:59'
      ]
      this.tableJson = this.tableJson2
      this.fClose()
      if (this.showFrmx) {
        this.partner_id = ''
      } else {
        this.partner_id = this.bykApi.global.fGetPlatform().partnerInfo.phone
      }
      if (!this.bykApi.smCom.fSmIsEmpty(this.$route.query.partnerId)) {
        this.partner_id = this.$route.query.partnerId
      }
      this.fQuerySearchGys(this.partner_id, 'ALL')
      this.init();
    },
    methods: {
      async init() {
        let res = await this.fGetMchPayDetail('LIST');
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        // if (this.nowPage == 1) {
        this.TR = res.page.TR || 0; //总条数
        this.TP = res.page.TP || 0; //总页数
        // }
        this.tableData = res.data;
        this.total = res.total;

      },

      async fModify(row) {
        this.frPop = true;
      },
      async fSave() {
        if (this.bykApi.smCom.fSmIsEmpty(this.frInfo.partner_id)) {
          return this.$message("服务商不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.frInfo.money)) {
          return this.$message("本次结算金额不能为空");
        }
        // return
        let res = await this.fPartnerLedgerSettlement();
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.init();
        this.fClose();
      },
      fClose() {
        this.frPop = false;
        this.frInfo = Object.assign({
          "user_phone": "",
          "partner_id": "",
          "soft_fr_now_money": "0",
          "user_name": "",
          "comp_name": "",
          "money": "0"
        });
      },
      //表格导出
      fExportDataEvent() {
        this.$refs.xTable1.exportData({
          type: 'csv'
        })
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        // console.log(this.sortType, type);
        // console.log(type, asc_desc);
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fOpenPop() {
        this.frPop = true;
      },
      //远程搜索商户
      async fQuerySearchGys(str, cb) {
        if (str == '全部') {
          str = ''
        }
        let orgRes = await this.fGetSubPartnerInfo(str)
        if (orgRes.result != 'sucess') {
          return this.$message(orgRes.msg)
        }
        this.orgListSub = orgRes.data
        if (cb == 'ALL') {
          this.orgListSub.unshift({
            comp_name: '全部',
            partner_id: '',
            user_phone: '',
          })
        }
      },
      // 选择分润商户
      fChgFrInfo(id) {
        if (id == 'ALL') {
          this.nowPage = 1
          this.init()
          this.frInfo.partner_id = ''
          if (this.partner_id != '全部') {
            this.frInfo.partner_id = this.partner_id
          }
          return
        }
        this.orgListSub.forEach((item, index) => {
          if (item.user_phone == id) {
            Object.assign(this.frInfo, item)
          }
        })
      },
      // 判断金额
      fRegMoney() {
        // if (this.frInfo.money > this.frInfo.soft_fr_now_money ) {
        //   this.frInfo.money = 0
        //   return this.$message('结算金额大于未结金额')
        // }
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fGetMchPayDetail('LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      async fSizeChange(e) {
        this.nowPage = 1;
        this.pageSize = e;
        let res = await this.fGetMchPayDetail('LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      // ------------- 请求 开始 --------------
      // PARTNER_PHONE_SIM
      // 获取下级列表信息
      async fGetSubPartnerInfo(searchStr) {
        let js = {};
        js["OPER"] = 'PARTNER_LIST_SIM';
        // js["PAGE_SIZE"] = 10;
        // js["NOW_PAGE"] = this.nowPage;
        js["SEARCH_STR"] = searchStr;
        // js["MH_YN"] ="Y"
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_PARTNER_INFO', js);
        console.log(res)
        return res;
      },

      async fGetMchPayDetail() {
        let methodName, oper;
        if (this.actTabs == '分润明细') {
          // oper = 'LIST'
          methodName = 'GET_PARTNER_LEDGER_DETAIL'
        } else {
          // oper = 'SETTLEMENT'
          methodName = 'GET_MCH_PAY_DETAIL'
        }
        let js = {};
        js["OPER"] = 'LIST'; // 必填 LIST MALL_ID
        js['START_TIME'] = this.frTime[0];
        js['OVER_TIME'] = this.frTime[1];
        js['PARTNER_PHONE'] = this.partner_id
        js['SEARCH_STR'] = this.searchStr
        js['NOW_PAGE'] = this.nowPage
        js['PAGE_SIZE'] = this.pageSize
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi(methodName, js);
        console.log(res)
        return res;
      },
      async fPartnerLedgerSettlement(oper) {
        let js = {};
        js["OPER"] = 'SETTLEMENT';
        js['USER_PHONE'] = this.frInfo.user_phone
        js['PAY_MONEY'] = this.frInfo.money
        js['REMARK'] = this.frInfo.remark
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_LEDGER_SETTLEMENT', js);
        console.log(res)
        return res;

      },


      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .takeaway {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .active {
      border-bottom: #409EFF 2px solid;
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 2px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  /* .x-w66{} */
  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/orgFrMx.vue